import { react2panel } from 'common/util/react2panel';
import { DecimalOption } from './decimal-option';
export const DecimalOptionEl = react2panel("decimal-option", DecimalOption);